export default __webpack_public_path__ + "static/media/ic-win.c99576fb.webp";